/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ArchivedBoardsIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ArchivedBoardsIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2ArchivedBoardsIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2ArchivedBoardsIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 14"
 style={{'--as-1-Zo597F': alignSelf,'--mt-2-Zo597F': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Zo597F': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Zo597F': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Zo597F': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Zo597F': opacity,'--w-10-Zo597F': typeof width === 'number' ? `${width}px` : width,'--h-11-Zo597F': typeof height === 'number' ? `${height}px` : height,'--f-12-Zo597F': fill,'--a-7-Zo597F': isAnimated ? animation : "none",'--sd-8-Zo597F': isAnimated ? strokeDashoffset : 0,'--sd-9-Zo597F': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2ArchivedBoardsIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M3.25 1a1 1 0 011-1h3a1 1 0 011 1v.5a1 1 0 01-1 1h-3a1 1 0 01-1-1V1zM9.5 1h.5a1.5 1.5 0 011.5 1.5v10A1.5 1.5 0 0110 14H1.5A1.5 1.5 0 010 12.5v-10A1.5 1.5 0 011.5 1H2v.5a2.25 2.25 0 002.25 2.25h3A2.25 2.25 0 009.5 1.5V1zM5.75 6.625c-.429 0-.831.114-1.179.313l3.241 3.24A2.375 2.375 0 005.75 6.625zm1.179 4.437l-3.241-3.24a2.375 2.375 0 003.241 3.24zM2.125 9a3.625 3.625 0 117.25 0 3.625 3.625 0 01-7.25 0z"
 style={{'--f-12-Zo597F': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}